
// IMPORTANT: This file is auto generated! Do not edit!
// tslint:disable
export const VERSION = 'local';
